// src/apis/aws.ts
// AWS S3 API 模块

import service from '@/utils/https';
import type { AxiosResponse } from 'axios';
import type { PresignedDownloadUrlResponse, TemporaryCredentialsResponse } from '@/types/aws';
import type { ApiResponse } from '@/types';

// 获取 S3 预签名下载 URL
export function getPresignedDownloadUrl(fileKey: string): Promise<AxiosResponse<ApiResponse<PresignedDownloadUrlResponse>>> {
  return service({
    url: '/v1/aws/presigned-download-url',
    method: 'get',
    params: { file_key: fileKey },
  });
}

// 获取 S3 临时凭证
export function getTemporaryCredentials(): Promise<AxiosResponse<ApiResponse<TemporaryCredentialsResponse>>> {
  return service({
    url: '/v1/aws/temporary-credentials',
    method: 'get',
  });
}

// 上传文件到 S3
export async function uploadToS3(uploadUrl: string, file: File): Promise<Response> {
  return fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
}
